import { SCREEN_BREAKPOINTS } from '../constants/screen-breakpoints.constant';

/**
 * Updates the viewport meta tag based on screen size
 */
export function updateViewportMeta(document: Document, width: number): void {
  let viewportContent = 'width=device-width, initial-scale=1.0';
  
  if (width <= SCREEN_BREAKPOINTS.mobile) {
    // Mobile viewport - prevent zooming, optimize for touch
    viewportContent = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
  } else if (width <= SCREEN_BREAKPOINTS.tablet) {
    // Tablet viewport
    viewportContent = 'width=device-width, initial-scale=1.0, maximum-scale=2.0, user-scalable=yes';
  } else {
    // Desktop viewport
    viewportContent = 'width=device-width, initial-scale=1.0';
  }
  
  // Find existing viewport meta tag or create new one
  let viewportMeta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;
  if (!viewportMeta) {
    viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    document.head.appendChild(viewportMeta);
  }
  viewportMeta.content = viewportContent;
}

/**
 * Updates viewport and handles window resize
 */
export function handleViewportResize(document: Document): void {
  const windowWidth = window.innerWidth;
  updateViewportMeta(document, windowWidth);
}
